// src/metaConfig.js
export const getMetaByCountry = (countryCode) => {
  const meta = {
    IN: {
      title: "Shop Premium USA Brands Online in UAE at Luxura Cart &ndash; Luxura Cart",
      description: 'Buy online Premium USA Brands in UAE from Luxura Cart with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    SA: {
      title: "Shop Premium USA Brands Online in Saudi Arabia at Luxura Cart &ndash; Luxura Cart",
      description: 'Buy online Premium USA Brands in Saudi Arabia from Luxura Cart with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    AE: {
      title: "Shop Premium USA Brands Online in UAE at Luxura Cart &ndash; Luxura Cart",
      description: 'Buy online Premium USA Brands in UAE from Luxura Cart with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    KW: {
      title: "Shop Premium USA Brands Online in Kuwait at Luxura Cart &ndash; Luxura Cart",
      description: 'Buy online Premium USA Brands in Kuwait from Luxura Cart with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    UK: {
      title: "Shop Premium USA Brands Online in United Kingdom at Luxura Cart &ndash; Luxura Cart",
      description: 'Buy online Premium USA Brands in United Kingdom from Luxura Cart with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    GB: {
      title: "Shop Premium USA Brands Online in United Kingdom at Luxura Cart &ndash; Luxura Cart",
      description: 'Buy online Premium USA Brands in United Kingdom from Luxura Cart with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    OM: {
      title: "Shop Premium USA Brands Online in Oman at Luxura Cart &ndash; Luxura Cart",
      description: 'Buy online Premium USA Brands in Oman from Luxura Cart with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    US: {
      title: "Shop Premium USA Brands Online in USA at Luxura Cart &ndash; Luxura Cart",
      description: 'Buy online Premium USA Brands in USA from Luxura Cart with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    BH: {
      title: "Shop Premium USA Brands Online in Bahrain at Luxura Cart &ndash; Luxura Cart",
      description: 'Buy online Premium USA Brands in Bahrain from Luxura Cart with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
    QA: {
      title: "Shop Premium USA Brands Online in Qatar at Luxura Cart &ndash; Luxura Cart",
      description: 'Buy online Premium USA Brands in Qatar from Luxura Cart with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
    },
  };

  return meta[countryCode] || meta["IN"]; // fallback to AE
};
